import { render, staticRenderFns } from "./RankingFilters.vue?vue&type=template&id=36fbcf73&scoped=true"
import script from "./RankingFilters.vue?vue&type=script&lang=js"
export * from "./RankingFilters.vue?vue&type=script&lang=js"
import style0 from "./RankingFilters.vue?vue&type=style&index=0&id=36fbcf73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbcf73",
  null
  
)

export default component.exports